<div class="report-border">
    <div class="row mar-top">
      <div class="col-md-12 header-font text-center color-blue">
        {{'common.Forever Business Owner Incentives' |translate | translateKey}}</div>
    </div>
    <!-- <div class="col-sm-3 col-6 text-left report-username">
            <b>{{userName | titleCase}} </b>
            <span class="applyBlock">({{distributorId}})</span>
        </div> -->
    <div class="row">
      <div class="text-right pad-right-20">
        <b>{{'common.Run Date:' |translate |translateKey}} </b>
        <span class="applyBlock">{{mydate}}</span>
      </div>
    </div>
  </div>


  <div class="col-md-12 no-padding mar-top card">
    <div class="col-md-5 ml-30">
      <ul class="list-group profileInfo-list-group">
        <!-- <li class="list-group-item clearfix"> -->
        <!-- <span>click to see full year casecredits</span> -->
        <div class="mar-top text-align-left">
          <div class="mar-bottom">
            <a class="login-menu font-size-15" [routerLink]="" (click)="getYearlyCaseCreditsDetails()">Click to see full year Case Credit report
                       </a>
          </div>

        </div>
        <!-- </li> -->
        <li class="list-group-item clearfix">
          <div class="col-xs-6 no-padding">
            <span class="header-font">
              {{'customer-service.CC Snapshot' |translate | translateKey}}
            </span>
          </div>
          <div class="col-xs-6">
            <div class="row">
              <span class="pull-right header-font color-blue">
                {{currentMonthCCValues?.totalCCMtd}}</span>
            </div>
            <div class="row">
              <span class="pull-right blockquote">{{'customer-service.Monthly Total' |translate | translateKey}}</span>
            </div>
          </div>
        </li>
        <!-- <li class="list-group-item">
        <div class="table-responsive">
          <table class="table">
            <tbody *ngIf="isLoading">
              <tr>
                <td colspan="3" class="text-center">{{'customer-service.Loading Results, Please wait.'
                                            |translate | translateKey}}.</td>
              </tr>
            </tbody>
            <tbody *ngIf="!isLoading && ccSnapshotMonthlyValues.length === 0">
              <tr>
                <td colspan="3" class="text-center">{{'customer-service.No record(s) found' |translate
                                            | translateKey}}.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </li> -->
        <li class="list-group-item">
          <div class="table-responsive">
            <table class="table grid-color">
              <thead class="color-white">
                <tr>
                  <th></th>
                  <th class="text-right color-blue">
                    {{'common.' + (prev3Month) + " " + pre3Year  |translate |translateKey}}

                  </th>
                  <th class="text-right color-blue">
                    {{'common.' + (prev2Month) + " " + pre2Year |translate |translateKey}}

                  </th>
                  <th class="text-right color-blue">
                    {{'common.' + (prevMonth) + " " + preYear |translate |translateKey}}

                  </th>
                  <th class="text-right color-blue">
                    {{'common.' + (curruMonth) + " " + currYear |translate |translateKey}}

                  </th>

                </tr>
              </thead>
              <colgroup>
                <col style="width: 220px;">
                <col style="width: 140px;">
                <col style="width: 300px;">
                <col style="width: 240px;">               
              </colgroup>
              <tbody class="text-right">
                              <tr>
                  <td class="text-left">Personal</td>                  
                    <td>
                      {{previous3MonthCCValues?.personalCCMtd}}</td>
                    <td>
                      {{previous2MonthCCValues?.personalCCMtd}}</td>
                    <td>
                      {{previousMonthCCValues?.personalCCMtd}}</td>
                    <td>
                      {{currentMonthCCValues?.personalCCMtd}}</td>
                 
                </tr>
                <tr>
                  <td class="text-left">New FBO</td>
                  
                    <td>
                      {{previous3MonthCCValues?.distributorCCMtd}}</td>
                    <td>
                      {{previous2MonthCCValues?.distributorCCMtd}}</td>
                    <td>
                      {{previousMonthCCValues?.distributorCCMtd}}</td>
                    <td>
                      {{currentMonthCCValues?.distributorCCMtd}}</td>
                </tr>
                <tr>
                  <td class="text-left">Total Active</td>
                    <td>
                      {{previous3MonthCCValues?.totalactiveCCMtd}}</td>
                    <td>
                      {{previous2MonthCCValues?.totalactiveCCMtd}}</td>
                    <td>
                      {{previousMonthCCValues?.totalactiveCCMtd}}</td>
                    <td>
                      {{currentMonthCCValues?.totalactiveCCMtd}}</td>
                </tr>
                <tr>
                  <td class="text-left">Non Manager</td>
                    <td>
                      {{previous3MonthCCValues?.nonmanagerCCMtd}}</td>
                    <td>
                      {{previous2MonthCCValues?.nonmanagerCCMtd}}</td>
                    <td>
                      {{previousMonthCCValues?.nonmanagerCCMtd}}</td>
                    <td>
                      {{currentMonthCCValues?.nonmanagerCCMtd}}</td>
                </tr>
                <tr>
                  <td class="text-left">Leadership</td>
                    <td>
                      {{previous3MonthCCValues?.leaderCC}}</td>
                    <td>
                      {{previous2MonthCCValues?.leaderCC}}</td>
                    <td>
                      {{previousMonthCCValues?.leaderCC}}</td>
                    <td>
                      {{currentMonthCCValues?.leaderCC}}</td>
                </tr>
                <tr>
                  <td class="text-left">Monthly Total</td>
                    <td>
                      {{previous3MonthCCValues?.totalCCMtd}}</td>
                    <td>
                      {{previous2MonthCCValues?.totalCCMtd}}</td>
                    <td>
                      {{previousMonthCCValues?.totalCCMtd}}</td>
                    <td>
                      {{currentMonthCCValues?.totalCCMtd}}</td>
                </tr>
                <tr>
                  <td class="text-left">Level</td>
                    <td title="{{getMemberLevel(previous3MonthCCValues?.endingLevel)}}" >
                      {{previous3MonthCCValues?.endingLevel > 0 ? previous3MonthCCValues?.endingLevel : "-" }}</td>
                    <td title="{{getMemberLevel(previous2MonthCCValues?.endingLevel)}}" >
                      {{previous2MonthCCValues?.endingLevel > 0 ? previous2MonthCCValues?.endingLevel : "-" }}</td>
                    <td title="{{getMemberLevel(previousMonthCCValues?.endingLevel)}}" >
                      {{previousMonthCCValues?.endingLevel > 0 ? previousMonthCCValues?.endingLevel : "-" }}</td>
                    <td title="{{getMemberLevel(currentMonthCCValues?.endingLevel)}}" >
                      {{currentMonthCCValues?.endingLevel > 0 ? currentMonthCCValues?.endingLevel : "-" }}</td>
                </tr>
                <tr>
                  <td class="text-left">4CC Active</td>
                  <ng-container *ngIf="previous3MonthCCValues?.currentMonthActive else currentMonthInactive">
                    <td>
                      {{'customer-service.Yes' |translate | translateKey}}</td>
                  </ng-container>
                  <ng-container *ngIf="previous2MonthCCValues?.currentMonthActive else currentMonthInactive">
                    <td>
                      {{'customer-service.Yes' |translate | translateKey}}</td>
                  </ng-container>
                  <ng-container *ngIf="previousMonthCCValues?.currentMonthActive else currentMonthInactive">
                    <td>
                      {{'customer-service.Yes' |translate | translateKey}}</td>
                  </ng-container>
                  <ng-container *ngIf="currentMonthCCValues?.currentMonthActive else currentMonthInactive">
                    <td>
                      {{'customer-service.Yes' |translate | translateKey}}</td>
                  </ng-container>
                  <ng-template #currentMonthInactive>
                    <td>{{'customer-service.No' |translate | translateKey}}</td>
                  </ng-template>
                    <!--<td>
                      {{previous3MonthCCValues?.currentMonthActive ? 'customer-service.Yes' |translate | translateKey : 'customer-service.No' |translate | translateKey}}</td>
                    <td>
                      {{previous2MonthCCValues?.currentMonthActive ? 'customer-service.Yes' |translate | translateKey : 'customer-service.No' |translate | translateKey}}</td>
                    <td>
                      {{previousMonthCCValues?.currentMonthActive ? 'customer-service.Yes' |translate | translateKey : 'customer-service.No' |translate | translateKey}}</td>
                    <td>
                      {{currentMonthCCValues?.currentMonthActive ? 'customer-service.Yes' |translate | translateKey : 'customer-service.No' |translate | translateKey}}</td>-->
                </tr>
                <tr>
                  <td class="text-left">Recaps</td>  
                  <td>                                
                    <div *ngIf="previous3MonthCCValues?.netMonthlyBonus !== '0.000' && country !=='null'">
                    <a [routerLink]="" (click)="getBonusRecap(previous3MonthCCValues?.processingMonth,previous3MonthCCValues?.processingYear)" >View Recap</a> 
                   
                    </div>
                  <div *ngIf="previous3MonthCCValues?.netMonthlyBonus === '0.000' || country =='null'">--</div> </td> 
                  <td>                                
                    <div *ngIf="previous2MonthCCValues?.netMonthlyBonus !== '0.000' && country !=='null'">
                    <a [routerLink]="" (click)="getBonusRecap(previous2MonthCCValues?.processingMonth,previous2MonthCCValues?.processingYear)" >View Recap</a> 
                   
                    </div>
                  <div *ngIf="previous2MonthCCValues?.netMonthlyBonus === '0.000' || country =='null' ">--</div> </td>
                  <td>                                
                    <div *ngIf="previousMonthCCValues?.netMonthlyBonus !== '0.000' && country !=='null'">
                    <a [routerLink]="" (click)="getBonusRecap(previousMonthCCValues?.processingMonth,previousMonthCCValues?.processingYear)" >View Recap</a> 
                   
                    </div>
                  <div *ngIf="previousMonthCCValues?.netMonthlyBonus === '0.000' || country =='null'">--</div> </td>
                  <td>                                
                  <div>--</div> </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      </ul>
      <div>


      </div>
    </div>


    <div class="col-md-5 col-sm-offset-1 pad-bottom">
      <div class="row widget-pad-bottom">
        <div class="col-sm-7 widget-pad-top text-align-left pad-left-15">
          <span class="widget-label color-blue font-size-18">Case Credits</span>
          <label class="" for="country">{{'common.Change Country' |translate |translateKey}} </label>
          <span class="cursor fa fa-question-circle-o report-title-tooltip"
            popover="{{'common.Select Country' |translate |translateKey}}" outsideClick="true" container="body"
            placement="right"></span>
        </div>
        <div class="col-sm-5 widget-pad-top left-padding-0">
          <select [(ngModel)]="selectedCountry" class="form-control padding" title="Select Country"
            (change)=(changeCountry(selectedCountry.value))>
            <option *ngFor="let country of countries" [ngValue]="country"> {{country.name}} </option>
          </select>
        </div>
      </div>
      <div class="row border-line text-align-left">
        <div class="col-sm-6 font-size-15 color-blue">Total Global CC Year-To-Date</div>
        <div class="col-sm-6 text-right header-font">
          {{ccSnapshot.totalGlobalCC | number:'1.3-3'}}</div>
      </div>
      <div class="row left-padding-0 right-padding-0 pt-10 mb-3">
        <div class="col-sm-8 p-0 cc-block text-align-left">
          <div class="d-sm-inline ">{{'dashboard.You have'|translate|translateKey}}
            {{managerCount}}
            <!-- </div>
              <div class="d-sm-inline"> -->
            {{'dashboard.out of'|translate|translateKey}}
            {{managerGoal}}&nbsp;</div>
        </div>
        <div class="col-sm-4 days-block pr-0 text-align-right"> {{remainingGoal}}
          {{'dashboard.remaining'|translate|translateKey}}</div>
      </div>
      <div class="row mb-3 incentive-progress">
        <!-- <div class="float-left col-md-12">Recognized Managers</div> -->
        <div class="col-sm-12">
          <div class="progress col-sm-6 d-flex left-padding-0 mt-25 align-items-center">
            <!-- <span>{{managerCount}}</span> -->
            <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
              [style.width]="managerCountPercentage + '%'">
            </div>
          </div>
          <div class="static-bar"></div>
          <!-- </div> -->
          <div class="col-sm-6 text-right font-size-count">{{managerCount}}</div>
          <div class="row col-sm-12 mb-30">
            <div class="col-sm-6 col-sm-6 d-flex align-items-center left-padding-0 px-0 cc-abel-font">
              <div class="earned-block pr-2 col-sm-6"></div>
              <span style="font-weight: bold;">&nbsp;{{managerCount}}
                {{'dashboard.Reached'|translate|translateKey}}</span>
            </div>
            <div class="col-md-6 col-sm-6 d-flex align-items-center left-padding-0 px-0 pt-2 pt-sm-0 cc-abel-font">
              <div class="needed-block pr-2 col-sm-6"></div>
              <span style="font-weight: bold;">&nbsp;{{remainingGoal}}
                {{'dashboard.Remaining'|translate|translateKey}} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="color-blue blockquote text-align-left">
        Next Level - {{ccSnapshot.nextLevel}}
      </div>
    </div>

  </div>
  <modal #caseCreditsdetails class="case-credits--popup">    
    <modal-header>
      <div class="color-blue text-left ">
        <span>{{'uplinereport.CASE CREDITS' |translate | translateKey}}</span>

        <span class="clearboth text-right float-right">
          <!-- <span class="fa fa-times" (click)="closePopup()"></span> -->
          <button type="button" class="ccSnapshotButton" (click)="closePopUp()">
            <span class="btn-label">
              <i class="fa fa-times"></i>
            </span>
          </button>
        </span>
      </div>
      <div>
        <!-- <div class="fa fa-chevron-left arrow" (click)="viewPreviousYearData()"></div> -->
        <span><button type="button" class="orderHistoryButton excel-hide" [disabled]="disableNextYear==true"
            (click)="viewPreviousYearData()">
            <span class="btn-label">
              <i class="fa fa-chevron-left"></i>
            </span>
          </button></span>
        <span>{{processingYear}}</span>

        <!-- <span class="fa fa-chevron-right arrow excel-hide" (click)="viewNextYearData()" [disabled]="isCurrentYear==true"></span> -->
        <span class="padding-l10"><button type="button" class="orderHistoryButton excel-hide"
            [disabled]="isCurrentYear==true" (click)="viewNextYearData()">
            <span class="btn-label">
              <i class="fa fa-chevron-right"></i>
            </span>
          </button></span>
      </div>
    </modal-header>
    <modal-content *ngIf="caseCreditsDetails">
       <div class="table-wrapper">
         <table class="table grid-color">
           <thead class="bonus-color">
            <tr class="table-color">
              <th class="color-black text-align">Months

              </th>
              <th class="column-header text-center">Jan</th>
              <th class="column-header text-center">Feb</th>
              <th class="column-header text-center">Mar</th>
              <th class="column-header text-center">Apr</th>
              <th class="column-header text-center">May</th>
              <th class="column-header text-center">Jun</th>
              <th class="column-header text-center">Jul</th>
              <th class="column-header text-center">Aug</th>
              <th class="column-header text-center">Sep</th>
              <th class="column-header text-center">Oct</th>
              <th class="column-header text-center">Nov</th>
              <th class="column-header text-center">Dec</th>
			  <th class="column-header text-center">Ytd</th>
              </tr>
            </thead>
                         <tbody>
              <tr>
                <th class="column-body">Personal</th>
                <td *ngFor="let c of caseCreditsDetails">{{c.personalCCMtd | number:'1.3-3'}}</td>
                <td>{{ytd.personalCCSum | number:'1.3-3'}}</td>
            </tr>

            <!-- <tbody> -->
            <tr>
              <th class="column-body">New FBO</th>
              <td *ngFor="let c of caseCreditsDetails">{{c.distributorCCMtd | number:'1.3-3'}}</td>
              <td>{{ytd.newFBOCCSum | number:'1.3-3'}}</td>
            </tr>
            <!-- </tbody> -->
            <tr>
              <th class="column-body">Total Active</th>
              <td *ngFor="let c of caseCreditsDetails">{{c.totalactiveCCMtd | number:'1.3-3'}}</td>
              <td>{{ytd.totalActiveCCSum | number:'1.3-3'}}</td>
            </tr>
            <tr>
              <th class="column-body">Non-Manager</th>
              <td *ngFor="let c of caseCreditsDetails">{{c.nonmanagerCCMtd | number:'1.3-3'}}</td>
              <td>{{ytd.nonManagerCCSum | number:'1.3-3'}}</td>
            </tr>
            <tr>
              <th class="column-body">Leadership</th>
              <td *ngFor="let c of caseCreditsDetails">{{c.leaderCC | number:'1.3-3'}}</td>
              <td>{{ytd.leaderShipCCSum | number:'1.3-3'}}</td>
            </tr>
            <tr>
              <th class="column-body">Total CC</th>
              <td *ngFor="let c of caseCreditsDetails">{{c.totalCCMtd | number:'1.3-3'}}</td>
              <td>{{ytd.totalCCSum | number:'1.3-3'}}</td>
            </tr>
            <tr>
              <th class="column-body">Level</th>
              <td title="{{getMemberLevel(c.endingLevel)}}" *ngFor="let c of caseCreditsDetails">{{c.endingLevel > 0 ? c.endingLevel : "-" }}</td>
              <td>--</td>
            </tr>
            <tr>
              <th class="column-body">4CC Active</th>
              <td *ngFor="let c of caseCreditsDetails">
                <ng-container *ngIf="c.currentMonthActive else currentMonth4CCInactive">
                    {{'customer-service.Yes' |translate | translateKey}}
                </ng-container>
                <ng-template #currentMonth4CCInactive>
                  {{'customer-service.No' |translate | translateKey}}
                </ng-template></td>
              <td>--</td>
            </tr>            
            <tr>
              <th class="column-body">Recaps</th>
              <td *ngFor="let c of caseCreditsDetails">               
                <div *ngIf="c.netMonthlyBonus !== 0.00 && (displayRecap || (c.processingYear === year && c.processingMonth!==isMonth)) && country !=='null' ">
                <a [routerLink]="" (click)="getBonusRecapData(c.processingMonth)" >View Recap</a>             
                </div>
              <div *ngIf="c.netMonthlyBonus === 0.00 || (!displayRecap && (c.processingYear === year && c.processingMonth === isMonth)) || country =='null'">--</div>
            </tr>
          </tbody>
        </table>
      </div>
    </modal-content>
  </modal>

<div class="color-blue col-md-12 text-center header-font py-4">Incentives / Bonuses</div>
<div id="iframeOuter" class="iframeOuter col-md-12 no-padding card" *ngIf="enableFLP360ReportPage">
    <div id="{{'spinner' + fboid}}">
        <img height="75" id="progressImg" src="https://cdn-titan.nextsphere.com/images/ns-processing.gif">   
    </div>
  <div id="iframeInner">
    <iframe id="{{'incentives' + fboid}}" name="incentives" 
      [src]="getFLP360ReportURL('incentives') | safeUrl"
      target="_parent"
      height="100" width="100%" frameborder="0" 
      sandbox="allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts allow-top-navigation-by-user-activation allow-top-navigation"
      style="visibility:hidden" (load)="applyIframeStyles()"
      >
    </iframe>
  </div>
</div>

<div class="container-fluid incentives-card-chart" *ngIf="!enableFLP360ReportPage">
  <div class="row">
      <div class="col">
              <div class="col-md-4 col-sm-6 py-4 incentive-banner-1">
                  <div class="py-3">
                      <div class="card">
                          <div class="card-body">
                              <app-spinner [spinnerName]="'globalrally'"></app-spinner>
                              <h5 class="card-title text-center pt-2">{{'incentives.Global Rally' | translate}}
                                  <span>
                                      <span class="cursor fa fa-question-circle-o report-title-tooltip" 
                                      popover="{{'incentives.Global Rally combined worldwide data' | translate}}" outsideClick="true" container="body"
                                      placement="right">
                                  </span>
                              </span>
                               <em class="float-right fa icon-20 d-lg-none d-md-none d-sm-none d-inline pl-1"></em>
                              </h5>
                              <div class="warning-msg text-center pt-3" *ngIf="globalRallyError">
                                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                  {{'incentives.Something Went Wrong' | translate}}
                              </div>
                              <div class="text-center warning-msg" *ngIf="!globalRallyFlag">
                                  {{'incentives.Global Rally data is not available for the selected country' |translate}}
                              </div>
                              <div *ngIf="isGlobalRallyData && globalRallyFlag">
                                  <div class="globalRallyList-1">
                                      <ul class="list-group">
                                          <li
                                              class="list-group-item d-flex justify-content-between align-items-center">
                                              {{'incentives.Global Rally CC' | translate}}
                                              <span
                                                  class="badge badge-primary badge-pill">{{getGlobalRally.globalRallyCC | number: '1.0-3'}}</span>
                                          </li>
                                          <li
                                              class="list-group-item d-flex justify-content-between align-items-center">
                                              {{'incentives.Global Rally Level' | translate}}
                                              <span
                                                  class="badge badge-primary badge-pill">{{getGlobalRally.currentLevelLabel}}</span>
                                          </li>
                                          <div *ngIf="!currentLevel">
                                              <li
                                                  class="list-group-item d-flex justify-content-between align-items-center">
                                                  {{'incentives.CC to Next Level' | translate}}
                                                  {{getGlobalRally.nextLevelLabel}}
                                                  <span
                                                      class="badge badge-primary badge-pill">{{getGlobalRally.ccToNextLevel | number:'3.1-3'}}</span>
                                              </li>
                                          </div>
                                      </ul>
                                  </div>
                                  <div class="globalRallyList-2 mt-4" *ngIf="isNextRewards">
                                      <div class="card-heading py-3">{{'incentives.Rewards' | translate}}</div>
                                      <ul class="list-group">
                                          <li class="list-group-item d-flex justify-content-between align-items-center"
                                              *ngFor="let rewards of getGlobalRallyRewards">
                                              {{'incentives.'+(rewards.rewardLabel)|translate}}
                                              <span
                                                  class="badge badge-primary text-uppercase badge-pill">{{rewards.rewardValue ? rewards.rewardValue : "-"}}</span>
                                          </li>
                                      </ul>
                                  </div>
                                  <div class="globalRallyList-3 mt-3" *ngIf="isNextLevelRewards">
                                      <div class="card-heading py-3">{{'incentives.Next Reward Level' | translate}}
                                      </div>
                                      <ul class="list-group">
                                          <li class="list-group-item d-flex justify-content-between align-items-center"
                                              *ngFor="let nextLevelRewards of getGlobalRallyNextLevelRewards">
                                              {{'incentives.'+(nextLevelRewards.rewardLabel)|translate}}
                                              <span class="badge badge-primary badge-pill text-uppercase">
                                                  {{nextLevelRewards.rewardValue ? nextLevelRewards.rewardValue : "-" }}</span>
                                          </li>
                                      </ul>
                                  </div>
                                  <div class="filter col-12 text-center align-item-center py-3" id="orders">
                                      <div class="btn filter-btn-1 col-4"
                                          (click)="getGlobalRallyData(globalRallyYear[0])"
                                          [class.active]="globalRallyYear[0]==globalRallyCurrentYear"
                                          *ngIf="globalRallyYear[0]"
                                          [class.new-filter-1]="globalRallyYear.length <= 1">
                                          {{globalRallyYear[0]}}</div><div class="btn filter-btn-2 col-4"
                                          (click)="getGlobalRallyData(globalRallyYear[1])"
                                          [class.active]="globalRallyYear[1]==globalRallyCurrentYear"
                                          *ngIf="globalRallyYear[1]"
                                          [class.new-filter-2]="globalRallyYear.length <= 2">
                                          {{globalRallyYear[1]}}</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="py-3">
                    <div class="card">
                        <div class="card-body">
                            <app-spinner [spinnerName]="'earned'"></app-spinner>
                            <h5 class="card-title text-center pt-2">{{'incentives.Forever2Drive' | translate}}
                                <em class="float-right fa icon-20 d-lg-none d-md-none d-sm-none d-inline pl-1"></em>
                            </h5>
                            <div class="warning-msg text-center pt-3" *ngIf="earnedIncentiveError">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                {{'incentives.Something Went Wrong' | translate}}
                            </div>
                            <div class="text-center warning-msg" *ngIf="!earnedIncentivesFlag">
                                {{'incentives.Forever2Drive data is not available for the selected country' |translate}}
                            </div>
                            <div *ngIf="isEarnedData && earnedIncentivesFlag">
                                <div class="forever2DriveList-1">
                                    <ul class="list-group">
                                        <li
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            {{'incentives.Qualification Level and Status' | translate}}
                                            <span class="pull-right">
                                              <span class="text-green helvetica-bold" *ngIf="getEarnedIncentives.earnedIncentiveLevel > 0">Level {{getEarnedIncentives.earnedIncentiveLevel}} - </span>
                                              <span class="helvetica-bold" [ngClass]= "(getEarnedIncentives.earnedIncentiveStatus === 'Not Qualified'  || getEarnedIncentives.earnedIncentiveLevel === 0 ) ? 'text-red' : 'text-green'"> 
                                                  {{getEarnedIncentives.earnedIncentiveStatus ? getEarnedIncentives.earnedIncentiveStatus : 'Not Qualified'}}</span>
                                              <span *ngIf="getEarnedIncentives.earnedIncentiveLevel > 0 && getEarnedIncentives.earnedIncentiveStatus !== 'Not Qualified'" class="pl-1 earned-checkbox-alignment">
                                                <label class="checkbox-position">
                                                  <input type="checkbox" disabled="disabled" checked="checked">
                                                  <span class="checkmark"></span>
                                                </label>
                                              </span>
                                            </span></li>
                                        <li
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            {{'incentives.4CC Active' | translate}}
                                            <!-- <span -->
                                                <!-- class="badge badge-primary badge-pill">{{getEarnedIncentives.earnedIncentiveLevel}}</span> -->
                                                <span class="badge badge-primary badge-pill" [ngClass]="getEarnedIncentives.currentMonthActive &&  getEarnedIncentives.currentMonthActive === 'true' ? 'text-green': 'text-red'">{{getEarnedIncentives.currentMonthActive  ? getEarnedIncentives.currentMonthActive === 'true' ? 'Yes' : 'No' : 'NA'}}</span>
                                              </li>
                                        <li
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            {{'incentives.Number of 1st Generation Active Managers' | translate}}
                                            <span
                                                class="badge badge-primary badge-pill">{{getEarnedIncentives.firstGenActiveManagersMonth3 ? getEarnedIncentives.firstGenActiveManagersMonth3 : 0}}</span>
                                        </li>
                                       
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                          <div class="col-6 p-0 text-left pl-3">{{'incentives.Total CC' | translate}}</div>
                                          <div class="pull-right col-4 p-0 pl-3">{{'incentives.You Have' | translate | translateKey}}: <a class="earned-anchor-color helvetica-bold" [ngClass]="getEarnedIncentives.earnedIncentiveMonth3Actual > 0 ? 'earned-text-decorator': 'pl-1'">{{getEarnedIncentives.earnedIncentiveMonth3Actual}}</a></div>
                                          <div class="col-2 p-0 pr-3 chairman-bg-color pull-right ">
                                            <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                                <div class="progress d-flex align-items-center">
                                                  <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                    [style.width]="totalCCPercentage + '%'">
                                                  </div>
                                                  <div class="static-bar"></div>
                                                </div>
                                              </div>
                                          </div>      
                                        </li>
                                      <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <div [ngClass]="getEarnedIncentives.earnedIncentiveLevel === 0 ? 'col-4': 'col-5'"></div>
                                        <div class="col-5 p-0" *ngIf="getEarnedIncentives.earnedIncentiveLevel > 0">{{'incentives.Required for full earnings' | translate}}:</div>
                                        <div class="p-0" [ngClass]="getEarnedIncentives.earnedIncentiveLevel === 0 ? 'col-6': 'col-5'" *ngIf="getEarnedIncentives.earnedIncentiveLevel === 0">{{'incentives.Required to Achieve Level 1' | translate}}:</div>
                                        <div class="helvetica-bold col-2 text-center pl-3 pr-2">{{requiredTotalCC}}</div> 
                                      </li>

                                        <li
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            {{'incentives.Qualification Start Date' | translate}}
                                            <span
                                                class="badge badge-primary badge-pill">{{getEarnedIncentives.earnedIncentiveQualDate? getEarnedIncentives.earnedIncentiveQualDate : '-'}}</span>
                                        </li>
                                        <li
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            {{'incentives.Qualification End Date' | translate}}
                                            <span
                                                class="badge badge-primary badge-pill">{{getEarnedIncentives.earnedIncentiveExpirationDate? getEarnedIncentives.earnedIncentiveExpirationDate : '-'}}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="forever2DriveList-2 mt-4">
                                <div class="card-heading py-3">
                                  {{'incentives.3 Months Qualification Data' | translate}}</div>
                                <div class='row-s border-bottom m-0 helvetica-bold'>
                                  <div class="col-2 px-1 pb-2 pt-2 text-center">
                                    {{'incentives.Month' | translate}}
                                  </div>
                                  <div class="col-2 p-0 pb-2 pt-2 earned-bg-color text-center">
                                    {{'incentives.1st Gen Managers' | translate}}
                                  </div>
                                  <div class="col-2 px-1 pb-2 pt-2 text-center">
                                    {{'incentives.Total CC' | translate}}
                                  </div>
                                  <div [ngClass]="getEarnedIncentives.earnedIncentiveLevel === 1 ? 'level-bg-color' : 'earned-bg-color' " class="col-2 px-1 pb-2 pt-2 text-center">
                                    {{'incentives.Level 1' | translate}}
                                  </div>
                                  <div [ngClass]="getEarnedIncentives.earnedIncentiveLevel === 2 ? 'level-bg-color' : '' " class="col-2 px-1 pb-2 pt-2 text-center">
                                    {{'incentives.Level 2' | translate}}
                                  </div>
                                  <div [ngClass]="getEarnedIncentives.earnedIncentiveLevel === 3 ? 'level-bg-color' : 'earned-bg-color' " class="col-2 px-1 pb-2 pt-2 text-center">
                                    {{'incentives.Level 3' | translate}}
                                  </div>
                                </div>
                                <div class='row-s border-bottom m-0'>
                                    <div class="font-9 col-2 px-0 pb-2 py-2 text-center helvetica-bold font-13">
                                      {{getEarnedIncentives.earnedIncentiveMonth3Name}}
                                    </div>
                                    <div class="col-2 px-1 pb-2 earned-bg-color py-2 text-center">
                                      {{getEarnedIncentives.firstGenActiveManagersMonth3 ? getEarnedIncentives.firstGenActiveManagersMonth3 : 0}}
                                    </div>
                                    <div class="col-2 px-1 pb-2 text-center py-2 earned-pad-x-0">
                                      <div class="">{{getEarnedIncentives.earnedIncentiveMonth3Actual}}</div>
                                      <div class="pt-2 helvetica-bold">{{'incentives.Required' |translate}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 earned-bg-color text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="currentMonthLevel1Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div> 
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth3Level1Required}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="currentMonthLevel2Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth3Level2Required}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 earned-bg-color text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="currentMonthLevel3Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth3Level3Required}}</div>
                                    </div>
                                  </div> 
                                  <div class='row-s border-bottom m-0'>
                                    <div class="font-9 col-2 px-0 pb-2 py-2 text-center helvetica-bold font-13">
                                      {{getEarnedIncentives.earnedIncentiveMonth2Name}}
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 earned-bg-color text-center">
                                      {{getEarnedIncentives.firstGenActiveManagersMonth2 ? getEarnedIncentives.firstGenActiveManagersMonth2 : 0}}
                                    </div>
                                    <div class="col-2 px-1 pb-2  py-2 text-center earned-pad-x-0">
                                      <div class="">{{getEarnedIncentives.earnedIncentiveMonth2Actual}}</div>
                                      <div class="pt-2 helvetica-bold">{{'incentives.Required' |translate}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2  py-2 earned-bg-color text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="previousMonthLevel1Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div> 
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth2Level1Required}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2  py-2 text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="previousMonthLevel2Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth2Level2Required}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2  py-2 earned-bg-color text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="previousMonthLevel3Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth2Level3Required}}</div>
                                    </div>
                                  </div> 
                                  <div class='row-s border-bottom m-0'>
                                    <div class="font-9 col-2 px-0 pb-2 text-center py-2 helvetica-bold font-13">
                                      {{getEarnedIncentives.earnedIncentiveMonth1Name}}
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 earned-bg-color text-center">
                                      {{getEarnedIncentives.firstGenActiveManagersMonth1 ? getEarnedIncentives.firstGenActiveManagersMonth1 : 0}}
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 text-center earned-pad-x-0">
                                      <div class="">{{getEarnedIncentives.earnedIncentiveMonth1Actual}}</div>
                                      <div class="pt-2 helvetica-bold">{{'incentives.Required' |translate}}  </div>
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 earned-bg-color text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="previous2MonthLevel1Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div> 
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth1Level1Required}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="previous2MonthLevel2Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth1Level2Required}}</div>
                                    </div>
                                    <div class="col-2 px-1 pb-2 py-2 earned-bg-color text-center">
                                      <div class="">
                                        <div class="pt-1 pb-2 incentive-progress bar-width-100">
                                            <div class="progress d-flex align-items-center">
                                              <div class="progress-bar border-radius-5" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [style.width]="previous2MonthLevel3Percentage + '%'">
                                              </div>
                                              <div class="static-bar"></div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="text-center">{{getEarnedIncentives.earnedIncentiveMonth1Level3Required}}</div>
                                    </div>                  
                                </div>
                              </div>                                  
                              <div class="filter col-12 text-center align-item-center py-3" id="orders">
                                <div class="btn filter-btn-1 col-4"
                                    (click)="getEarnedIncentivesData(earnedCurrentYear,earnedCurrentMonth)"
                                    [class.active]="earnedIncentiveMonth==earnedCurrentMonth"
                                    *ngIf="earnedCurrentYear">
                                    {{getEarnedIncentives.earnedIncentiveMonth3YearName}}</div><div class="btn filter-btn-3 col-4"
                                    (click)="getEarnedIncentivesData(earnedPreviousMonthYear, earnedPreviousMonths)"
                                    [class.active]="earnedIncentiveMonth==earnedPreviousMonths"
                                    *ngIf="earnedPreviousYears">
                                    {{getEarnedIncentives.earnedIncentiveMonth2YearName}}</div><div class="btn filter-btn-2 col-4"
                                    (click)="getEarnedIncentivesData(earnedPrevious2MonthYear, earnedPrevious2Months)"
                                    [class.active]="earnedIncentiveMonth==earnedPrevious2Months"
                                    *ngIf="earnedBeforeYears">
                                    {{getEarnedIncentives.earnedIncentiveMonth1YearName}}</div>
                            </div>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
              <div class="col-md-4 col-sm-6 py-4 incentive-banner-2">
                <div class="py-3">
                  <div class="card">
                    <div class="card-body">
                      <app-spinner [spinnerName]="'eaglemanager'"></app-spinner>
                      <em class="float-left fa fa-angle-left" (click)="getEagleManagerByYearIncentivesData(eagleManagersYear)"
                        *ngIf="displayFBODetails"></em>
                      <h5 class="card-title text-center pt-2">{{'incentives.Eagle Manager' | translate}}
                      </h5>
                      <div class="eagleManagerList pb-1 text-center p-0" [class.d-none]="badEagleManagerData">
                        {{operatingCountry}} ({{'incentives.Home Country Only' |translate}})
                      </div>
                      <div class="warning-msg text-center pt-3" [class.d-none]="eagleManagerError==false || badEagleManagerData">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'common.Something Went Wrong' | translate}}
                      </div>
                      <div class="text-center warning-msg" [class.d-none]="eagleManagerFlag==true || badEagleManagerData">
                        {{'incentives.Eagle Manager data is not available for the selected country' |translate}}
                      </div>
                      <div *ngIf="badEagleManagerData" class="badEagleManagerData px-2 pt-3" >
                        {{'incentives.Due to the extension of the Eagle Manager qualification period until the end of May, Eagle Manager data is not correctly represented in CSP'|translate}} <br>
                       <br> {{'incentives.Please contact your local office to get a more accurate representation of your progress toward Eagle Manager qualification'|translate}} <br>
                       <br>  {{'incentives.We appreciate your patience and understanding'|translate}} <br>
                       <br>
                       <br>
                     </div>
                      <div *ngIf="isEagleManagerData && !badEagleManagerData">
                        <div class="eagleManagerList" [class.d-none]="!eagleManagerFlag">
                          <div class="text-center bold py-1">{{'incentives.Qualified' |translate}}:
                            <span
                              [ngClass]="isEagleManagerQualified? 'text-green': 'text-red'">{{isEagleManagerQualified ? 'Yes' : 'No'}}</span>
                          </div>
                          <div class="p-2 border-top">
                            <div class="bold text-left">{{'incentives.Total CC' |translate}}</div>
                            <div class="row">
                              <span class="col-xs-7 p-0 pl-3 text-left">
                                <span class="pl-1">{{'incentives.Required' |translate}}: 720</span>
                                <br />({{'incentives.including 100 New CC' |translate}})</span>
                              <span class="col-xs-5 pr-3 p-0 text-right">{{'incentives.You have' |translate}}:
                                <span [ngClass]="eagleManagerTotalCC!==0 ? 'eagleManagerCCByCountry' : ''"
                                  (click)="navigateToEagleManagerSummaryCountry()">
                                  <span class="bold">{{eagleManagerTotalCC}}</span></span></span></div>
                            <div class="incentive-progress" [ngClass]="showCheckBox()? 'bar-width-90': 'bar-width-100'">
                              <div class="progress d-flex align-items-center">
                                <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                  [ngClass]="eagleManagerTotalPercentage === 100 ? 'border-radius-5': ''"
                                  [style.width]="eagleManagerTotalPercentage + '%'">
                                </div>
                                <div class="static-bar"></div>
                              </div>
                            </div>
                            <div *ngIf="eagleManagerTotalCC >= 720" class="pull-right checkbox-alignment text-right">
                              <label class="checkbox-position">
                                <input type="checkbox" disabled="disabled" checked="checked">
                                <span class="checkmark"></span>
                              </label>
                            </div>
                            <div class="text-center">{{'incentives.Your Qualifying Country is' |translate}} <span
                                class="bold">{{countryDisplayName}}</span></div>
                          </div>
                          <div class="border-top pt-2">
                            <div class="px-2 bold text-left">
                              {{'incentives.New CC' |translate }}
                            </div>
                            <div class=" px-2 row">
                              <span class="col-xs-7 p-0 pl-4 text-left">{{'incentives.Required' |translate}}: 100</span>
                              <span class="col-xs-5 pr-3 p-0 text-right">{{'incentives.You have' |translate}}:
                                <span [ngClass]="eagleManagerGlobalCC!==0 ? 'eagleManagerCCByCountry' : ''"
                                  (click)="navigateToEagleManagerSummaryCountry()">
                                  <span class="bold">{{eagleManagerGlobalCC}}</span></span></span>
                            </div>
                            <div class="px-2 py-2">
                              <div class=" incentive-progress" [ngClass]="showCheckBox()? 'bar-width-90': 'bar-width-100'">
                                <div class="progress d-flex align-items-center">
                                  <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                    [ngClass]="eagleManagerGlobalPercentage === 100 ? 'border-radius-5': ''"
                                    [style.width]="eagleManagerGlobalPercentage + '%'">
                                  </div>
                                  <div class="static-bar"></div>
                                </div>
                              </div>
                            </div>
                            <ul class="list-group">
                              <div *ngIf="eagleManagerGlobalCC >= 100" class="px-2 pull-right checkbox-alignment text-right">
                                <label class="checkbox-position">
                                  <input type="checkbox" disabled="disabled" checked="checked">
                                  <span class="checkmark"></span>
                                </label>
                              </div>
                              <li class="list-group-item  text-capitalize">
                                <div class="d-flex justify-content-between align-items-center">
                                  {{'incentives.New Non-Manager CC in Qualifying Country' |translate}}
                                  <span class="badge badge-primary badge-pill" *ngIf="getEagleManagers">
                                    {{getEagleManagers.qualifyingCountryNonManagerCC || 0}}</span>
                                </div>
                              </li>
                              <li class="list-group-item  text-capitalize">
                                <div class="d-flex justify-content-between align-items-center">
                                  <span>{{'incentives.New Non-Manager CC in other Countries' |translate}}
                                  </span>
                                  <span class="badge badge-primary badge-pill" *ngIf="getEagleManagers">{{getEagleManagers.nonQualifyingCountryNonManagerCC || 0}}</span>
                                </div>
                                <div class="remaining">
                                  <span>({{'incentives.Max 100 CC Allowed' |translate}})</span>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class="p-2 new-supervisor-list">
                            <div class="bold text-left">
                              {{'incentives.New Supervisors' |translate}}
                            </div>
                            <div class="row">
                              <span class="col-xs-7 p-0 pl-3 text-left">
                                <span class="pl-1">{{'incentives.Required' |translate}}: 2</span>
                              </span>
                              <span class="col-xs-5 pr-3 p-0 text-right">
                                <span *ngIf="getEagleManagers">{{'incentives.You have' |translate}}: <span
                                    class="bold">{{getEagleManagers.numberOfNewSupervisors}}</span>
                                </span>
                                <div *ngIf="showCheckBox()" class="pull-right checkbox-alignment-top">
                                  <label class="checkbox-position"
                                    [ngClass]="getEagleManagers.numberOfNewSupervisors >= 2 ? 'display' : 'display-none'">
                                    <input type="checkbox" disabled="disabled" checked="checked">
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </span>
                            </div>
                          </div>
                          <div class="p-2 border-bottom" *ngIf="isEagleManagerQualified">
                            <div>
                              <span class="bold">{{'incentives.Eagle Manager Lines' |translate}}</span>
                              <span class="float-right" *ngIf="getEagleManagers">{{'incentives.You have' |translate}}: <span
                                class="bold" *ngIf="getEagleManagers.numberOfEagleManagerLines > 0">
                                <span id="{{eagleManagerLinesUrl}}"
                                  class="">{{getEagleManagers.numberOfEagleManagerLines}}</span></span>
                              <span class="bold"
                                *ngIf="getEagleManagers.numberOfEagleManagerLines === 0">0</span></span>
                            </div>
                          </div>
                          <div class="pt-3 pb-2 text-center" *ngIf="getEagleManagers">
                            {{'incentives.You have' |translate}} <span class="bold"
                              *ngIf="getEagleManagers.numberOfEagleManagers === 0">0</span> <span class="bold"
                              *ngIf="getEagleManagers.numberOfEagleManagers > 0" id="{{eagleManagerURL}}">{{getEagleManagers.numberOfEagleManagers}}</span>&nbsp;
                            <span
                              *ngIf="getEagleManagers.numberOfEagleManagers > 1">{{'incentives.Eagle Managers in your downline' |translate}}</span>
                            <span
                              *ngIf="getEagleManagers.numberOfEagleManagers < 2">{{'incentives.Eagle Manager in your downline' |translate}}</span>.
                          </div>
                        </div>
                        <div class="filter col-12 text-center align-item-center py-3" id="orders">
                          <div class="btn col-4 filter-btn-1" id="eagle-filter-btn-1"
                            (click)="getEagleManagerByYearIncentivesData(eagleManagerCurrentYear)"
                            [class.active]="eagleManagersYear==eagleManagerCurrentYear" *ngIf="eagleManagerCurrentYear">
                            {{'incentives.April 30'|translate | translateKey}}, {{eagleManagerNewCurrentYear}}</div><div class="btn filter-btn-2 col-4" id="eagle-filter-btn-2"
                            (click)="getEagleManagerByYearIncentivesData(eagleManagerPreviousYear)"
                            [class.active]="eagleManagersYear==eagleManagerPreviousYear" *ngIf="eagleManagerPreviousYear">
                            {{'incentives.April 30'|translate | translateKey}}, {{eagleManagerNewPreviousYear}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="py-3">
                  <div class="card">
                    <div class="card-body">
                      <app-spinner [spinnerName]="'leadership'"></app-spinner>
                      <h5 class="card-title text-center pt-2">{{'incentives.Leadership Bonus' | translate}}
                        <em class="float-right fa icon-20 d-lg-none d-md-none d-sm-none d-inline pl-1"></em>
                      </h5>
                      <div class="warning-msg text-center pt-3" [class.d-none]="leadershipError==false">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{'common.Something Went Wrong' | translate}}
                      </div>
                      <div class="text-center warning-msg" [class.d-none]="leadershipFlag==true">
                        {{'errorMessage.Leadership Bonus data is not available for the selected country' |translate}}
                      </div>
                      <div *ngIf="isLeadershipData" [class.d-none]="leadershipFlag==false">
                        <div class="leadershipBonusList mt-3" *ngIf="getLeadershipBonus">
                          <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              {{'incentives.Recognized Manager' | translate}}
                              <span
                                class="badge badge-primary badge-pill">{{getLeadershipBonus.recognizedManager==true  ? 'YES' : getLeadershipBonus.recognizedManager==false ? ['NO'] : '--'}}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              {{'incentives.Number of Leadership Managers' | translate}}
                              <span class="badge badge-primary badge-pill">{{getLeadershipBonus.numberOfLeadershipManagers}}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              {{'incentives.Leadership Bonus Qualified' | translate}}
                              <span
                                class="badge badge-primary badge-pill">{{getLeadershipBonus.leadershipQualifiedFlag==true  ? 'YES' : getLeadershipBonus.leadershipQualifiedFlag==false ? ['NO'] : '--'}}</span>
                            </li>
                            <li class="list-group-item  text-capitalize">
                              <div class="d-flex justify-content-between align-items-center">
                                <span> {{'incentives.Leadership Bonus CC' | translate}}</span>
                               
                                <span
                                  class="badge badge-primary badge-pill">{{getLeadershipBonus.leadershipCCsActual | number: '1.0-3'}}</span>
                              </div>
                              <div class="remaining ml-2 mr-auto">
                                <span>{{getLeadershipBonus.leadershipCCsRequired}}
                                  {{'incentives.Required'|translate}}</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="filter col-12 text-center align-item-center py-3" id="orders">
                          <div class="btn filter-btn-1 col-4" (click)="getLeadershipBonusData(leadershipMonth[0])"
                            [class.active]="leadershipMonth[0]==leadershipCurrentMonth"
                            [class.new-filter-1]="leadershipMonth.length <= 1" *ngIf="leadershipMonth[0]">
                            {{leadershipMonth[0]}}</div><div class="btn filter-btn-3 col-4" (click)="getLeadershipBonusData(leadershipMonth[1])"
                            [class.active]="leadershipMonth[1]==leadershipCurrentMonth"
                            [class.new-filter-2]="leadershipMonth.length <= 2" *ngIf="leadershipMonth[1]">
                            {{leadershipMonth[1]}}</div><div class="btn filter-btn-2 col-4" (click)="getLeadershipBonusData(leadershipMonth[2])"
                            [class.active]="leadershipMonth[2]==leadershipCurrentMonth" *ngIf="leadershipMonth[2]">
                            {{leadershipMonth[2]}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 py-4 incentive-banner-3">
                  <div class="py-3">
                      <div class="card">
                          <div class="card-body">
                              <app-spinner [spinnerName]="'chairman'"></app-spinner>
                              <em class="float-left fa fa-angle-left" (click)="showChairmanBonusDetails()"
                              *ngIf="displayChairmanBonus"></em>
                          <h5 class="card-title text-center pt-2">{{'incentives.Chairmans Bonus' | translate}}
                              <em class="float-right fa icon-20 d-lg-none d-md-none d-sm-none d-inline pl-1"></em>
                          </h5>
                          <div class="warning-msg text-center pt-3" *ngIf="chairmanBonusError">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                              {{'incentives.Something Went Wrong' | translate}}
                          </div>
                          <div class="text-center warning-msg" *ngIf="!chairmanBonusFlag">
                              {{'incentives.Chairmans Bonus data is not available for the selected country' |translate}}
                          </div>
                          <div *ngIf="isChairmanData && chairmanBonusFlag">
                              <div class="chairmanBonusList" *ngIf="!displayChairmanBonus">
                                  <ul class="list-group">
                                      <li
                                          class="list-group-item d-flex justify-content-between align-items-center">
                                          {{'incentives.Home Personal N/M CC' | translate}}
                                          <span
                                              class="badge badge-primary badge-pill">{{getChairmanBonus.chairmansBonusPersonalNonManagerCC | number: '1.0-3'}}</span>
                                      </li>
                                      <li
                                          class="list-group-item d-flex justify-content-between align-items-center">
                                          {{'incentives.Home New N/M CC' | translate}}
                                          <span
                                              class="badge badge-primary badge-pill">{{getChairmanBonus.newCharimansBonusHomeCountryCC | number: '1.0-3'}}</span>
                                      </li>
                                      <li
                                          class="list-group-item d-flex justify-content-between align-items-center">
                                          {{'incentives.Non-Home New N/M CC' | translate}}
                                          <span
                                              class="badge badge-primary badge-pill">{{getChairmanBonus.newCharimansBonusNonHomeCountryCC | number: '1.0-3'}}</span>
                                      </li>
                                      <li
                                          class="list-group-item d-flex justify-content-between align-items-center">
                                          {{'incentives.Global New N/M CC' | translate}}
                                          <span
                                              class="badge badge-primary badge-pill">{{getChairmanBonus.newCharimansBonusGlobalCC | number: '1.0-3'}}</span>
                                      </li>
                                      <li
                                          class="list-group-item d-flex justify-content-between align-items-center">
                                          {{'incentives.Chairman Bonus Manager Lines' | translate}}
                                          <span
                                              class="badge badge-primary badge-pill">{{getChairmanBonus.numberOfChairmansBonusManagers}}</span>
                                      </li>
                                      <li
                                          class="list-group-item d-flex justify-content-between align-items-center">
                                          {{'incentives.600CC Managers' | translate}}
                                          <span
                                              class="badge badge-primary badge-pill">{{getChairmanBonus.numberOfDownlineManagersWith600CC}}</span>
                                      </li>
                                  </ul>
                                  <div class="card-heading-eagle pt-4" [class.d-none]="getChairmanBonus.numberOfCBQualifiers===0">
                                      <div class="d-flex justify-content-between align-items-center">
                                          <span>{{'incentives.FBOs CB Qualifiers' | translate}}</span>
                                          <div class="float-right chairmanBonus-btn">
                                              <button type="submit" class="btn btn-primary text-uppercase"
                                                  (click)="showChairmanBonusFBOs()">
                                                  {{'incentives.View' | translate}}
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="chairmanBonusList-2 pb-3" *ngIf="displayChairmanBonus">
                                  <ul class="list-group">
                                      <li class="list-group-item"
                                          *ngFor="let ChairmanBonusQualifier  of getChairmanBonusQualifiers">

                                          <div class="d-flex justify-content-between align-items-center">
                                              <span> {{ChairmanBonusQualifier.firstName}}
                                                  {{ChairmanBonusQualifier.lastName}}</span>
                                              <span
                                                  class="badge badge-primary badge-pill">{{ChairmanBonusQualifier.downlineLeg}}</span>
                                          </div>
                                          <div class="fboId">
                                              <span>{{ChairmanBonusQualifier.foreverFboId}}
                                              </span>
                                          </div>
                                      </li>
                                  </ul>
                              </div>
                              <div class="filter col-12 text-center align-item-center py-3" id="orders">
                                  <div class="btn filter-btn-1 col-4"
                                      (click)="getChairmanBonusIncentivesData(chairmanBonusYear[0])"
                                      [class.active]="chairmanBonusYear[0]==chairmanCurrentYear"
                                      *ngIf="chairmanBonusYear[0]"
                                      [class.new-filter-1]="chairmanBonusYear.length <= 1">
                                      {{chairmanBonusYear[0]}}</div><div class="btn filter-btn-2 col-4"
                                      (click)="getChairmanBonusIncentivesData(chairmanBonusYear[1])"
                                      [class.active]="chairmanBonusYear[1]==chairmanCurrentYear"
                                      *ngIf="chairmanBonusYear[1]"
                                      [class.new-filter-2]="chairmanBonusYear.length <= 2">
                                      {{chairmanBonusYear[1]}}</div>
                              </div>
                          </div>
                          </div>
                      </div>
                  </div>
                  <div class="py-3">
                      <div class="card">
                          <div class="card-body">
                              <app-spinner [spinnerName]="'gem'"></app-spinner>
                              <em class="float-left fa fa-angle-left" (click)="showGemBonusDetails()"
                             *ngIf="displayFirstGemManager || displaySilverGemManager"></em>
                          <h5 class="card-title text-center pt-2">{{'incentives.Gem Bonus' | translate}}
                              <em class="float-right fa icon-20 d-lg-none d-md-none d-sm-none d-inline pl-1"></em>
                          </h5>
                          <div class="warning-msg text-center pt-3" *ngIf="gemBonusError">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                              {{'incentives.Something Went Wrong' | translate}}
                          </div>
                          <div class="text-center warning-msg" *ngIf="!gemBonusFlag">
                              {{'incentives.Not Qualified to Gem Bonus for the selected month' |translate}}
                          </div>
                          <div *ngIf="isGemBonusData">
                              <div *ngIf="gemBonusFlag">
                                  <div class="gemBonusList-1" *ngIf="!displayFirstGemManager && !displaySilverGemManager && getGemBonus">
                                      <ul class="list-group pb-3">
                                          <li
                                              class="list-group-item d-flex justify-content-between align-items-center">
                                              <span>{{'incentives.Potential 1st Gen Active Managers' | translate}}
                                                  <span class="cursor fa fa-question-circle-o report-title-tooltip" 
                                                  popover="{{'incentives.This field shows the count of ALL the Potential 1st Gen Managers no matter how deep they are in your downline' | translate}}" outsideClick="true" container="body"
                                                  placement="right"></span>
                                                 </span>
                                              <span
                                                  class="badge badge-primary badge-pill">{{getGemBonus.numberOfFirstGenerationActiveRecognizedManagers}}</span>
                                          </li>
                                      </ul>
                                      <div class="card-heading py-4"
                                          [class.d-none]="getGemBonus.numberOfFirstGenerationActiveRecognizedManagers==0">
                                          <div class="d-flex justify-content-between align-items-center">
                                              <span>{{'incentives.FBO’s Potential 1st Gen Active Managers' | translate}}</span>
                                              <div class="float-right gemBonus-btn">
                                                  <button type="submit" class="btn btn-primary text-uppercase"
                                                      (click)="showFirstGemManager()">
                                                      {{'incentives.View'| translate}}
                                                  </button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="gemBonusList-3 pb-3" *ngIf="displayFirstGemManager">
                                      <ul class="list-group">
                                          <li class="list-group-item"
                                              *ngFor="let firstGemManager of firstGenerationGemDetails">

                                              <div class="d-flex justify-content-between align-items-center">
                                                  <span> {{firstGemManager.firstName}}
                                                      {{firstGemManager.lastName}}</span>
                                                  <span
                                                      class="badge badge-primary badge-pill">{{firstGemManager.downlineLeg}}</span>
                                              </div>
                                              <div class="fboId">
                                                  <span>{{firstGemManager.foreverFboId}}
                                                  </span>
                                              </div>
                                          </li>
                                      </ul>
                                  </div>
                                  <div class="gemBonusList-2" *ngIf="!displaySilverGemManager && !displayFirstGemManager && getGemBonus">
                                      <ul class="list-group pb-3 mt-2">
                                          <li
                                              class="list-group-item d-flex justify-content-between align-items-center">
                                              <span>{{'incentives.Potential 25 CC Active Managers' | translate}}
                                                  <span class="cursor fa fa-question-circle-o report-title-tooltip" 
                                                  popover="{{'incentives.This field shows the count of ALL the Potential 25CC Active Managers' | translate}}" outsideClick="true" container="body"
                                                  placement="right"></span>
                                              </span>
                                              <span
                                                  class="badge badge-primary badge-pill">{{getGemBonus.numberOfDownlineManagers25CC}}</span>
                                          </li>
                                      </ul>
                                      <div class="card-heading-gem py-3"
                                          [class.d-none]="getGemBonus.numberOfDownlineManagers25CC==0">
                                          <div class="d-flex justify-content-between align-items-center">
                                              <span>{{'incentives.FBO’s Potential 25 CC Active Managers' | translate}}</span>
                                              <div class="float-right gemBonus-btn">
                                                  <button type="submit" class="btn btn-primary text-uppercase"
                                                      (click)="showSilverGemManager()">
                                                      {{'incentives.View' | translate}}
                                                  </button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="gemBonusList-4 pb-3"
                                      *ngIf="displaySilverGemManager">
                                      <ul class="list-group">
                                          <li class="list-group-item"
                                              *ngFor="let silverManagers of silverCCGemManager">

                                              <div class="d-flex justify-content-between align-items-center">
                                                  <span> {{silverManagers.firstName}}
                                                      {{silverManagers.lastName}}</span>
                                                  <span
                                                      class="badge badge-primary badge-pill">{{silverManagers.downlineLeg}}</span>
                                              </div>
                                              <div class="fboId"><span>{{silverManagers.foreverFboId}}</span>
                                              </div>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                              <div class="filter col-12 text-center align-item-center py-3" id="orders">
                                  <div class="btn filter-btn-1 col-4"
                                      (click)="getGemBonusIncentivesData(gemBonusMonth[0])"
                                      [class.active]="gemBonusMonth[0]==gemBonusCurrentMonth"
                                      *ngIf="gemBonusMonth[0]" [class.new-filter-1]="gemBonusMonth.length <= 1">
                                      {{gemBonusMonth[0]}}
                                  </div><div class="btn filter-btn-3 col-4"
                                      (click)="getGemBonusIncentivesData(gemBonusMonth[1])"
                                      [class.active]="gemBonusMonth[1]==gemBonusCurrentMonth"
                                      *ngIf="gemBonusMonth[1]" [class.new-filter-2]="gemBonusMonth.length <= 2">
                                      {{gemBonusMonth[1]}}
                                  </div><div class="btn filter-btn-2 col-4"
                                      (click)="getGemBonusIncentivesData(gemBonusMonth[2])"
                                      [class.active]="gemBonusMonth[2]==gemBonusCurrentMonth"
                                      *ngIf="gemBonusMonth[2]">{{gemBonusMonth[2]}}
                                  </div>
                              </div>
                          </div>
                          </div>
                      </div>
                  </div>
              </div>
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/incentives.component.html